import { createStorefrontApiClient } from '@shopify/storefront-api-client'
import { isEmpty } from 'lodash'

export const getStorefrontClient = () => {
  const publicAccessToken = window.__GLOBAL__.storefrontAccessToken

  if (isEmpty(publicAccessToken)) {
    // eslint-disable-next-line no-console
    console.error('Storefront access token is not populated!')

    return
  }

  return createStorefrontApiClient({
    storeDomain: window.Shopify.shop,
    apiVersion: '2024-10',
    publicAccessToken
  })
}
